import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { my24 } from 'UI/constants/dimensions';

export const gridStyles = makeStyles(theme => ({
  locationCheckBox: {
    margin: theme.spacing(3, 0)
  },
  divider: {
    border: `1px solid ${theme.palette.customColors.lightgrey}`,
    width: '100%',
    display: 'block',
    margin: my24
  },
  checkbox: {
    width: 20,
    height: 20,
    color: theme.palette.primary.main,
    marginRight: 10,
    marginLeft: 10
  },
  checked: {
    color: `${theme.palette.primary.main} !important`
  }
}));

export const StyledForm = withStyles({
  root: {
    margin: 0
  }
})(FormControlLabel);
